/**
 * Get number value and unit
 * @param {PropertyValueProps} data
 */
const getNumberValueAndUnit = (data) => {
  /** Convert seconds to milliseconds */
  if (data.get("unit") === "s") {
    const value = /** @type {Number} */ (data?.get("value"));
    data.set("value", value * 1000);
  }

  return data;
};

export default getNumberValueAndUnit;
